import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bibShape, checkedOutItemShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';

import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import accountShape from 'app/shapes/accountShape';
import { checkoutTransactionsShape } from 'app/shapes/borrowing';
import DownloadForm from './DownloadForm';

export default class DownloadModal extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClose() {
    this.props.modalActions.closeModal(this.props.modalKey);
  }

  render() {
    const {
      digitalFormats,
      bib,
      checkoutTransactions,
      currentAccount,
      isLoading,
      bibsActions,
      checkoutActions,
      checkoutItem,
      modalKey
    } = this.props;

    return (
      <ModalContainer className="cp-download-modal" modalKey={modalKey} handleClose={this.handleClose}>
        <DownloadForm
          bib={bib}
          handleClose={this.handleClose}
          digitalFormats={digitalFormats}
          checkoutTransactions={checkoutTransactions}
          currentAccount={currentAccount}
          bibsActions={bibsActions}
          checkoutActions={checkoutActions}
          checkoutItem={checkoutItem}
          isLoading={isLoading}
        />
      </ModalContainer>
    );
  }
}

DownloadModal.propTypes = {
  bib: bibShape.isRequired,
  modalKey: PropTypes.string.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentAccount: accountShape.isRequired,
  checkoutItem: checkedOutItemShape.isRequired,
  isLoading: PropTypes.bool,
  checkoutTransactions: checkoutTransactionsShape.isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  checkoutActions: PropTypes.objectOf(PropTypes.func).isRequired,
  digitalFormats: ImmutablePropTypes.list
};
